import { cn } from '@/lib/utils'
import { useEffect, useRef } from 'react'

export interface TableCheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
	indeterminate?: boolean
}

export function TableCheckbox({ className, indeterminate = false, ...props }: TableCheckboxProps) {
	const inputRef = useRef<HTMLInputElement>(null)

	useEffect(() => {
		const el = inputRef.current
		if (el) {
			el.indeterminate = indeterminate
		}
	}, [indeterminate])

	return (
		<input
			ref={inputRef}
			type='checkbox'
			className={cn('table-checkbox transition-opacity duration-200', className)}
			{...props}
		/>
	)
}
